<div class="applied-facets">
  <div class="container-filter">
    <span class="title">{{ 'facets.filtersApplied' | translate }}</span>
    <button class="clear" (click)="clearFilter()">
      <span>{{ 'facets.cleanFilters' | translate }}</span>
      <span class="material-symbols-outlined icon-filter">filter_list_off</span>
    </button>
  </div>

  <div class="applied-facets-container">
    @if (facets.length) {
      @for (item of facets; track $index) {
        <div class="facet" *ngFor="let facet of item.facets">
          <span class="label">{{ facet.name }}</span>

          <button type="button" (click)="close(facet)">
            <span class="material-symbols-outlined close"> close </span>
          </button>
        </div>
      }
    }
  </div>
</div>
